package com.bulut.mecitogullari.data.repository

import com.bulut.mecitogullari.core.session.toUser
import com.bulut.mecitogullari.data.model.User
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.GoogleAuthProvider
import dev.gitlive.firebase.auth.auth

interface AuthRepository {
    /** Exchanges a Google ID and/or access token for a Firebase session. */
    suspend fun loginWithGoogle(idToken: String?, accessToken: String?): Result<User>

    /** Anonymous Firebase session (App Store misafir girişi gereksinimi). */
    suspend fun loginAsGuest(): Result<User>

    suspend fun logout()
}

class FirebaseAuthRepository : AuthRepository {

    override suspend fun loginWithGoogle(idToken: String?, accessToken: String?): Result<User> =
        runCatching {
            require(idToken != null || accessToken != null) { "Google oturum bilgisi alınamadı." }
            val credential = GoogleAuthProvider.credential(idToken, accessToken)
            val result = Firebase.auth.signInWithCredential(credential)
            result.user?.toUser() ?: error("Giriş başarısız oldu.")
        }

    override suspend fun loginAsGuest(): Result<User> =
        runCatching {
            val result = Firebase.auth.signInAnonymously()
            result.user?.toUser() ?: error("Misafir girişi başarısız oldu.")
        }

    override suspend fun logout() {
        Firebase.auth.signOut()
    }
}
